export default __webpack_public_path__ + "static/media/418.30efe1b4.png";